/**
 * Documentation shown under the type field of App Configuration (TypeDocs).
 * Key: configuration type (custom types use their custom type name).
 * Written for CMS editors: no technical terms.
 */
export default {
    'force-update-version': {
        title: 'How the force update works',
        items: [
            'Write "true" in Config value to turn the force update on. Any other value turns it off.',
            'When it is on, users with an app version lower than the iOS / Android minimum version see a screen that asks them to update the app from the store. They cannot use the app until they update.',
            'Some phones are too old to install the new app version. If the phone system version is lower than the iOS / Android minimum OS version, the user sees a message saying that the phone is no longer supported, and can keep using the app.',
            'This message is shown only once. It is shown again only if you set a higher minimum OS version.',
            'Leave the minimum OS version fields empty if you do not want to show this message.',
            'iOS / Android minimum version: the app version as shown in the store, three numbers separated by dots, e.g. 2.32.0.',
            'iOS minimum OS version: the iOS version, e.g. 16.4 or 17.',
            'Android minimum OS version: the Android version, e.g. 10 or 8.1.',
            'Write versions with numbers and dots only: no letters, spaces or commas (write 16.4, not 16,4 or iOS 16).',
        ],
    },
};
